var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveWishlist24 = function SvgRemoveWishlist24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "remove_wishlist_24_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".remove_wishlist_24_svg__st0{fill:none;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10}.remove_wishlist_24_svg__st2{display:inline}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "remove_wishlist_24_svg__st0",
    d: "m7.1 7.2 9.7 9.8M16.8 7.2 7.1 17"
  })));
};
export default SvgRemoveWishlist24;